import React from 'react';
import { BsPencil } from 'react-icons/bs';

export function ProfileModal({
  title,
  onClose,
  disabled,
  children,
}: {
  title: string;
  onClose: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div className="fin-modal-backdrop" onClick={() => !disabled && onClose()}>
      <div className="fin-modal acq-modal profile-modal" onClick={(e) => e.stopPropagation()}>
        <div className="fin-modal-header">
          <h2 className="fin-modal-title">{title}</h2>
          <button type="button" className="fin-modal-close" onClick={onClose} disabled={disabled}>
            &times;
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

export const ProfileField = ({ label, value }: { label: string; value: React.ReactNode }) => (
  <div className="profile-field">
    <span className="profile-field-label">{label}</span>
    <span className="profile-field-value">{value}</span>
  </div>
);

export const ProfileSectionCard = ({
  title,
  subtitle,
  onEdit,
  editable = true,
  children,
  footer,
}: {
  title: string;
  subtitle: string;
  onEdit?: () => void;
  editable?: boolean;
  children: React.ReactNode;
  footer?: React.ReactNode;
}) => (
  <section className="profile-detail-card">
    <div className="profile-detail-card-header">
      <div className="profile-detail-card-titles">
        <h3 className="profile-detail-card-title">{title}</h3>
        <p className="profile-detail-card-sub">{subtitle}</p>
      </div>
      {editable && onEdit && (
        <button type="button" className="profile-edit-btn" onClick={onEdit} title={`Edit ${title.toLowerCase()}`}>
          <BsPencil size={13} />
        </button>
      )}
    </div>
    <div className="profile-fields">{children}</div>
    {footer}
  </section>
);
